<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/iotdm/device/page" getKey="rows"
      :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeiSN')">
            <el-input v-model="yt.conditions.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wangguanSN')">
            <yi_cross_select :max="1" :component="'admin_iotdm_gateway_list'"
              :ids.sync="yt.conditions.gatewayId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('suoshukehu')">
            <!-- <yi_data_select multiple :type="'customer'" :ids.sync="yt.conditions.customerIds"></yi_data_select> -->
            <yi_cross_select :max="1" :component="'admin_customer_info_list'"
              :ids.sync="yt.conditions.deviceCustomerId">
            </yi_cross_select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
              plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear()">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
          {{$t('xinzeng')}}
        </el-button>
        <el-button size="mini" @click="show = !show" plain>
          {{$t('daoru')}}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
            </el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()">
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('shishishuju', scope.row)">{{$t('shishishuju')}}
            </el-button>
          </el-col>

          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
              @click="yt.remove(scope.row,'/web/iotdm/device/delete')">{{$t('shanchu')}}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeiSN')" required>
            <el-input v-model="yt.editObj.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xieyimingcheng')" required>
            <!-- <yi_data_select :type="'customer'" :ids.sync="yt.editObj.customerId"></yi_data_select> -->
            <yi_cross_select :max="1" :component="'admin_iotdm_protocol_list'"
              :ids.sync="yt.editObj.protocolId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('wangguanSN')" required>
            <yi_cross_select :max="1" :component="'admin_iotdm_gateway_list'"
              :ids.sync="yt.editObj.gatewayId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shifoutongzhiyichang')" required>
            <el-select v-model="yt.editObj.isNotifyException" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>

        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" @click="yt.req('POST','/web/iotdm/device/create')" type="primary">
            {{$t('baocun')}}
          </el-button>
        </template>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeiSN')" required>
            <el-input disabled v-model="yt.editObj.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xieyimingcheng')" required>
            <!-- <yi_data_select :type="'customer'" :ids.sync="yt.editObj.customerId"></yi_data_select> -->
            <yi_cross_select :max="1" :component="'admin_iotdm_protocol_list'"
              :ids.sync="yt.editObj.protocolId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('wangguanSN')" required>
            <yi_cross_select :max="1" :component="'admin_iotdm_gateway_list'"
              :ids.sync="yt.editObj.gatewayId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shifoutongzhiyichang')" required>
            <el-select v-model="yt.editObj.isNotifyException" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" @click="yt.req('POST','/web/iotdm/device/update')" type="primary">
            {{$t('baocun')}}
          </el-button>

        </span>
      </template>
      <!-- 复制 -->
      <template v-if="yt.editObj.action == 'fuzhi'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yuanshebeiSN')" class="noborder">
            <el-input disabled v-model="yt.editObj.sn">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeixinghao')" class="noborder">
            <el-input disabled v-model="yt.editObj.modelCode">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeiSN')" required>
            <el-input v-model="yt.editObj.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshukehu')" required>
            <yi_cross_select :max="1" :component="'admin_customer_info_list'"
              :ids.sync="yt.editObj.customerId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')" required>
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" @click="yt.req('POST','/web/iotdm/device/copy')" type="primary">{{$t('baocun')}}
          </el-button>
        </span>
      </template>
      <!-- 实时数据弹窗 -->
      <template v-if="yt.editObj.action == 'shishishuju'">
        <div class="dialog-scroller">
          <realtime_data :device="yt.editObj"></realtime_data>
        </div>
      </template>
    </el-dialog>
    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import importExcel from '@@/pages/admin/iotdm/device/import_excel'
import realtime_data from '@@/pages/admin/iotdm/device/realtime_data'
	export default {

		name: 'admin_iotdm_device_list',
    components: {
      importExcel,
      realtime_data
    },
    props: {
      timer:null
    },
		data() {
			return {
				list: [],
        show: false,
        statusMap: {},
				/*modelColumns: [{
						label: 'shebeileixing',
						prop: 'seriesTypeId',
						type: 'dictionary',
						key: 'EQUIPMENT_TYPES',
						width: 150
					},
					{
						label: 'shebeixiliemingcheng',
						prop: 'seriesName',
						width: 130
					},
					{
						label: 'shebeixinghao',
						prop: 'code',

					}
				],*/
				columns: [{
          label: 'shebeizhuangtai',
          prop: 'deviceState.currentState',
          width: 120,
          type: 'tag',
          tags: {
            '-1': {
              color: '#909399',
              text: this.$t('lixian')
            },
            '0': {
              color: '#67C23A',
              text: this.$t('zaixian')
            },
            '': {
              color: '#419FFF',
              text: '未配置'
            }
          },
        },{
          label: 'tongdaozhuangtai',
          prop: 'deviceState.channelState',
          width: 120,
          type: 'tag',
          tags: {
            '-1': {
              color: '#909399',
              text: this.$t('lixian')
            },
            '1': {
              color: '#67C23A',
              text: this.$t('zhengchang')
            },
            '0': {
              color: '#F56C6C',
              text: this.$t('tongdaoyichang')
            },
            '': {
              color: '#419FFF',
              text: '未配置'
            }
          },
        },{
					label: 'shebeiSN',
					prop: 'sn',
				}, {
					label: 'shebeimingcheng',
					prop: 'name'
				},{
					label: 'xieyimingcheng',
					prop: 'protocol.name'
				}, {
					label: 'wangguanSN',
					prop: 'gateway.sn'
				}, {
					label: 'iccid',
					prop: 'cardIccid'
				}, {
          label: 'beizhu',
          prop: 'remark'
        }, {
          label: 'zuihoushangxianshijian',
          prop: 'deviceState.recentOfflineTimestamp',
          type: 'time',
          width: 180,
        },{
          label: 'shifoutongzhiyichang',
          prop: 'isNotifyException',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 110
        }, {
          label: 'caozuo',
          type: 'slot',
          width: 260,
          fixed: 'right'
        }]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
				}
				this.yt.get(1);
        this.utils.event_hub.$on('IOTDM_DEVICE_REFRESH', () => {
          this.yt.get();
        })
			}, 300);
      this.timer = setInterval(() => {
        this.getStatusOfGateways()
      }, 15000)
		},
    destroyed() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
		methods: {
      // 获取网关状态
      async getStatusOfGateways() {
        const sns = []
        for (let i = 0; i < this.yt.list.length; i++) {
          sns.push(this.yt.list[i].sn)
        }
        this.http.post('/web/iotdm/device/getStateOfDevices', this.yt.list).then((res) => {
          this.statusMap = res.data
          for (let i = 0; i < this.yt.list.length; i++) {
            var currentsn =  this.yt.list[i].sn;
            this.yt.list[i].deviceState = this.statusMap[currentsn];

            //this.yt.list[i].deviceState.channelState = this.statusMap[currentsn] == null || this.statusMap[currentsn] === undefined ? -1 : this.statusMap[currentsn].deviceState.channelState;
            //this.yt.list[i].deviceState.recentOfflineTimestamp = this.statusMap[this.yt.list[i].sn] == null || this.statusMap[this.yt.list[i].sn] === undefined ? -1 : this.statusMap[this.yt.list[i].sn].deviceState.recentOfflineTimestamp;
          }
        }).catch(error => {
          console.log(error)
        })
      },
    }
	};
</script>
